import { uniq } from "lodash-es";
const uuidPattern = `[a-f0-9]{8}_[a-f0-9]{4}_[a-f0-9]{4}_[a-f0-9]{4}_[a-f0-9]{12}`;
const commaUuidPattern = "(" + uuidPattern + "(ZZZ" + uuidPattern + "){0,}" + ")+";
const idRegex = new RegExp("\\$item_" + commaUuidPattern, "g");
export const __NULL__ = { __NULL__: "__NULL__" };
export function encodeItemIdAsExprVar(id) {
    return "$item_" + id.replace(/-/g, "_").replace(/,/g, "ZZZ");
}
export function decodeItemIdFromExpr(id) {
    return id.substring(6).replace(/_/g, "-").replace(/ZZZ/g, ",");
}
export function getReferencedItemIdsInExpr(expr) {
    return uniq([...expr.matchAll(idRegex)]
        .flatMap(r => (r[0] ? [r[0]] : []))
        .map(id => decodeItemIdFromExpr(id)));
}
//# sourceMappingURL=props2.js.map